import React from 'react';
import 'presentation/components/styles/TypingIndicator.css';

export default function TypingIndicator() {
  return (
    <div className="typingIndicator" data-aid="gladlyChatTypingIndicator">
      <span className="typingIndicator_dots" />
      <span className="typingIndicator_dots" />
      <span className="typingIndicator_dots" />
    </div>
  );
}
